import script from "./WarehousesView.vue?vue&type=script&setup=true&lang=js"
export * from "./WarehousesView.vue?vue&type=script&setup=true&lang=js"

import "./WarehousesView.vue?vue&type=style&index=0&id=7d208c69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d208c69"]])

export default __exports__